import { AsYouType } from 'mui-tel-input'
import { countriesWithCode } from 'src/common/utils'

export function getCountryData(input: string) {
  const defaultCountryCode = input.substr(0, 1) !== '+' ? 'US' : undefined
  const asYouType = new AsYouType(defaultCountryCode)
  let formatted = asYouType.input(input)
  let countryCode: string | undefined = ''
  let withoutCountryCode = formatted
  let countrySymbol: string | undefined = asYouType.getCountry()

  if (defaultCountryCode === 'US') {
    countryCode = '+1'
    formatted = '+1 ' + formatted
    countrySymbol = 'US'
  } else {
    const parts = formatted.split(' ')
    countryCode = parts.length > 1 ? parts.shift() : ''
    withoutCountryCode = parts.join(' ')
  }

  const countryWithCode = countriesWithCode.find(({ code }) => countrySymbol === code)

  return {
    formatted,
    withoutCountryCode: withoutCountryCode,
    countryWithCode: countryWithCode || { name: 'United States', code: 'US', phone: 1 },
    countrySymbol,
    countryCode,
  }
}
